// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ModuleType = 'AUDIO' | 'EMBED' | 'GALLERY' | 'IMAGE' | 'LIVESTREAM' | 'TEXT' | 'VIDEO' | 'VIDEO360';

export type TopArticlesQueryVariables = Exact<{
	withCacheTags?: boolean | null | undefined;
}>;

export type TopArticlesQuery = {
	topArticles: {
		__typename: 'ArticlesConnection';
		nodes: Array<{
			__typename: 'Article';
			modulesTypes: Array<ModuleType | null>;
			path: string;
			publicationDate: string | null;
			rowId: string;
			teaserText: string | null;
			title: string;
			breakingnewsEnd: string | null;
			withCache?: Array<string> | null;
			image: {
				__typename: 'ModuleImage';
				altText: string | null;
				copyright: string | null;
				title: string | null;
				url: string | null;
			} | null;
		} | null>;
	} | null;
};

export const TopArticlesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TopArticles' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'withCacheTags' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
					defaultValue: { kind: 'BooleanValue', value: false },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'topArticles' },
						name: { kind: 'Name', value: 'allArticles' },
						arguments: [
							{ kind: 'Argument', name: { kind: 'Name', value: 'orderBy' }, value: { kind: 'EnumValue', value: 'PUBLICATION_DATE_DESC' } },
							{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '10' } },
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'status' },
											value: {
												kind: 'ObjectValue',
												fields: [
													{
														kind: 'ObjectField',
														name: { kind: 'Name', value: 'equalTo' },
														value: { kind: 'EnumValue', value: 'PUBLISHED' },
													},
												],
											},
										},
									],
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'nodes' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'modulesTypes' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'teaserText' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'image' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'altText' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
													],
												},
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'breakingnewsEnd' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'withCache' },
												directives: [
													{
														kind: 'Directive',
														name: { kind: 'Name', value: 'include' },
														arguments: [
															{
																kind: 'Argument',
																name: { kind: 'Name', value: 'if' },
																value: { kind: 'Variable', name: { kind: 'Name', value: 'withCacheTags' } },
															},
														],
													},
												],
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<TopArticlesQuery, TopArticlesQueryVariables>;
